import { Nilable } from "@shared/utils";

export interface IRespuestaDiaDTO {
    day: string;
    count: number;
}

export class RespuestaDiaDTO {
    public dia = new Date();
    public cantidad = 0;

    constructor(json: Nilable<Partial<IRespuestaDiaDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IRespuestaDiaDTO>) {
        if (json.day != null) {
            this.dia = new Date(Date.parse(json.day));
        }
        if (json.count != null) {
            this.cantidad = json.count;
        }
    }
}
